import React from "react";

export default function Four({ fill, children }) {
  return (
    <svg
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      width="300"
      height="300"
      viewBox="0 0 300 300"
    >
      <path d="M249,91.43H61.37a10.22,10.22,0,0,0-10.21,10.21V289.23a10.22,10.22,0,0,0,10.21,10.21H248.89a10.33,10.33,0,0,0,10.28-10.21V101.64A10.22,10.22,0,0,0,249,91.43Zm2.31,194.67a5.5,5.5,0,0,1-5.51,5.52H64.5A5.51,5.51,0,0,1,59,286.1V104.77a5.51,5.51,0,0,1,5.52-5.52H245.76a5.5,5.5,0,0,1,5.51,5.52Z" />
      <path d="M60.47,60.42H190l14,21.47a2.35,2.35,0,0,0,3.28,0l14-21.47h28.25a9.24,9.24,0,0,0,9.24-9.24V9.67A9.24,9.24,0,0,0,249.56.42H60.47a9.2,9.2,0,0,0-9.24,9.25V51.18A9.24,9.24,0,0,0,60.47,60.42Z" />
      {children}
    </svg>
  );
}
